export default class MapModel {
    constructor(popup) {
        this.popup = popup;
        this.popupFields = [
            'incdttm', 'location', 'sdot_coldesc', 
            'pedcount', 'severitydesc', 'pedcylcount', 
            'injuries', 'fatalities', 'seriousinjuries'
        ];

        this.map = L.map( document.getElementById('map') ).setView([47.6062, -122.3321], 11);    
    }
    
    /**
     * Set the tiles for the map.
     */
    setTiles() {
        L.tileLayer('http://korona.geog.uni-heidelberg.de/tiles/roads/x={x}&y={y}&z={z}', {
            attribution: 'Imagery from <a href="http://giscience.uni-hd.de/">GIScience Research Group @ University of Heidelberg</a> &mdash; Map data &copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>'
        }).addTo(this.map);
    };

    /**
     * Make a marker for the map with an optional popup.
     */
    marker(shape, popup) {
        let marker = L.marker( [ shape.latitude, shape.longitude ] );
        
        if (popup) {
            marker.bindPopup(popup);
        }

        return marker;
    }

    /**
     * Add heatmap to the map.
     */
    addHeat(data) {
        L.heatLayer(data, { radius: 30, blur: 20 }).addTo(this.map);
    };

    /**
     * Add the Marker Groups to the map
     */
    addMarkerGroups(markers) {
        this.map.addLayer( L.markerClusterGroup().addLayers(markers) );
    }

    /**
     * Add a marker to the map
     */
    addMarker(row) {     
        let popup = this.popup.content(row, this.popupFields);
        return this.marker(row.shape, popup);
    }

    /**
     * Check if there are valid coordinates.
     */
    areValidCoordinates(row) {
        if (row.shape.latitude && row.shape.longitude) {
            return true;
        }

        return false;
    }

    // getBounds() {
    //     this.map.getBounds();
    // }
}


// WEBPACK FOOTER //
// ./js/Models/MapModel.js